<template>
  <div class="cars-manage">
    <QS-h3-title>
      <template slot="title">车辆信息详情</template>
    </QS-h3-title>
    <div class="title-info">
      <div v-for="item in headInfoKeyList" :key="item.key" class="title-info-item">
        {{item.name}}：{{headInfo[item.key]||'--'}}
      </div>
      </div>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="(item) in renderTabList" :label="item.label" :name="item.name" :key="item.name">
        <component
          v-if="activeName==item.name"
          :is="item.componentName"
          :id="carId"
          :params="{ carId }"
          :carState="carState"
          :plateNo="headInfo.plateNo"
          :exitOperationState="exitOperationState"
          :carId="carId"
          :isShowAddBtn="isShowAddBtn"
          :modelId="carInfo.modelId"
          :vin="headInfo.vin"
          isCarDetail
          />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Policy from '@/pages/carsService/insurance/components/policyList.vue' // 保单
import CarAccidentList from '../components/CarAccidentList.vue' // 事故
import CarDetails from '../components/carDetails.vue' // 车辆详情
import LicenceDetails from '../components/licenceDetails.vue' // 证照
import CarViolation from './pages/carViolation/index.vue' // 违章
import CarMaintenanceList from '../components/CarMaintenanceList.vue' // 维保
import enterpriseChildOrder from './pages/enterpriseChildOrder/index.vue' // 企业子订单
import comeOutRecord from './pages/comeOutRecord/index.vue' // 出入库记录
import personalOrder from './pages/personalOrder/index.vue'
import { tabConfig } from './config'
import {
  getCarDetails,
} from '@/api/domain/cars'

export default {
  components: {
    Policy,
    CarAccidentList,
    CarMaintenanceList,
    CarDetails,
    LicenceDetails,
    CarViolation,
    enterpriseChildOrder,
    comeOutRecord,
    personalOrder,
  },
  props: ['tabName'],
  data() {
    return {
      carInfo: {},
      renderTabList: tabConfig(this),
      activeName: '',
      plateNo: '', // 车牌号
      carId: '', // 车辆ID
      carState: '', // 车辆状态
      exitOperationState: '', // 是否退出运营
      headInfoKeyList: [
        { key: 'plateNo', name: '车牌号' },
        { key: 'brandName', name: '品牌' },
        { key: 'seriesName', name: '车系' },
        { key: 'modelName', name: '车型' },
        { key: 'vin', name: 'VIN码' },
        { key: 'carId', name: '车辆ID' },
      ],
      headInfo: {
        plateNo: '',
        brandName: '',
        seriesName: '',
        modelName: '',
        vin: '',
        carId: this.carId,
      },
    }
  },
  computed: {
    isShowAddBtn() {
      return (Number(this.carState) !== 10 || (Number(this.carState) === 10 && this.plateNo)) && Number(this.carState) !== 5
    },
  },
  created() {
    // 需要从详情页返回到车辆详情页映射tab关联数据
    const renderTabItem = this.renderTabList.find((item) => item.componentName === this.tabName)
    this.carId = this.$route.query.id
    const { source } = this.$route.query
    if (renderTabItem) {
      this.activeName = renderTabItem.name
    } else if (source) {
      this.activeName = source
    } else {
      this.activeName = 'detail'
    }
    this.plateNo = this.$route.query.plateNo
    this.getCarDetails()
    this.headInfo.carId = this.$route.query.id
  },
  methods: {
    async getCarDetails() {
      const { data } = await getCarDetails({ id: this.carId })
      data.carInfo && (this.carState = data.carInfo.carState)
      this.carInfo = data.carInfo
      this.exitOperationState = data.carInfo.exitOperationState
      this.headInfo.brandName = data.carInfo.brandName
      this.headInfo.seriesName = data.carInfo.seriesName
      this.headInfo.modelName = data.carInfoModel.modelName
      this.headInfo.vin = data.carLicenseInfo.vin
      this.headInfo.plateNo = this.$route.query.plateNo ? this.$route.query.plateNo : data.carLicenseInfo.plateNo
    },
  },
}
</script>
<style scoped lang="scss">
.el-tabs ::v-deep .el-tabs__item.is-active {
  color: #333;
}
::v-deep .el-tabs__content {
  width: 100%;
  height: calc(100% - 56px);
  overflow-y: auto;
}
.title-info{
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  color: #303133;
  line-height: 22px;
  flex-wrap: wrap;
  &-item{
    width: 25%;
    margin-bottom: 8px;
  }
}
</style>
